module.exports = __webpack_public_path__ + "static/media/banner-slider-img3.2dfdd977.png";